/**
 * Support – SVG icon.
 */
import Screen from '@screen';

export default function SupportIcon({
  width,
  height,
  margin,
}: {
  width?: number;
  height?: number;
  margin?: string;
}) {
  return (
    <svg
      width={(width ? width : 72) * Screen.widthRatio}
      height={(height ? height : 84) * Screen.widthRatio}
      viewBox='0 0 72 84'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M35.7236 0C55.508 0.000120606 71.4472 15.9021 71.4473 35.4277V38.6436C71.4474 38.6572 71.4482 38.6709 71.4482 38.6846V48.7539C71.4482 68.0778 55.4126 83.293 35.7246 83.293C33.9869 83.2929 32.5783 81.8841 32.5781 80.1465V74.2227C32.5784 72.4851 33.987 71.0762 35.7246 71.0762H44.6094C46.347 71.0763 47.7556 72.4851 47.7559 74.2227C47.7559 74.3448 47.7469 74.4655 47.7334 74.584C53.9662 71.9374 59.0176 67.2837 62.0459 61.4746C60.3154 62.1753 58.4268 62.5625 56.4512 62.5625C54.7134 62.5624 53.3047 61.1538 53.3047 59.416V35.7236C53.3048 33.9859 54.7134 32.5772 56.4512 32.5771C59.6899 32.5771 62.6956 33.6152 65.1523 35.375C65.1236 19.3864 52.0518 6.29309 35.7236 6.29297C19.3961 6.29303 6.32279 19.3853 6.29297 35.373C8.74922 33.614 11.7544 32.5773 14.9922 32.5771C16.73 32.5771 18.1396 33.9859 18.1396 35.7236V59.416C18.1396 61.1538 16.73 62.5625 14.9922 62.5625C6.73923 62.5622 0 55.8224 0 47.5693C1.55344e-05 47.1585 0.0170283 46.7514 0.0498047 46.3486C0.0176504 46.1683 1.95703e-05 45.9826 0 45.793V35.4277C6.64318e-05 15.9021 15.9393 6.54142e-05 35.7236 0ZM11.8457 39.4668C8.60785 40.7373 6.29321 43.9001 6.29297 47.5693C6.29297 51.2387 8.60788 54.4012 11.8457 55.6719V39.4668ZM59.5977 55.6719C62.8358 54.4013 65.1504 51.2389 65.1504 47.5693C65.1501 43.8999 62.8358 40.7372 59.5977 39.4668V55.6719Z'
        fill='url(#paint0_linear_settings_support)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_settings_support'
          x1='35.7241'
          y1='0'
          x2='35.7241'
          y2='83.2928'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
      </defs>
    </svg>
  );
}
